const feConfig = window?.feConfig
const apiEnv = feConfig?.apiEnv
const feConfigAll = Object.assign({}, feConfig?.common, feConfig[apiEnv])

export const imagesBaseUrl =
  feConfigAll.imagesBaseUrl || 'https://images.yxt.com/'
export const easemobWebsdk =
  window.__EASEMOB_WEBSDK__ || `${imagesBaseUrl}stc/js/IM/websdk3.3.2.js`

// export const yxtwebimWebsdk =
//   `${
//     window.__YXTIM_WEBSDK__ ||
//     'https://meetcdn.yxt.com/sdk/imweb/sdk/YxtWebIM-dev.js'
//   }?v=` + Date.now() // 自研sdk

export const yxtwebimWebsdk = `${feConfigAll.staticBaseUrl}assets/84b23970/25cd6983/yxtwebim-min.js`
